import { Component, EventEmitter, Inject, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ErrorModalComponent } from '../../../components/tools/modals/error-modal/error-modal.component';
import { CategoriasGastosService } from '../../../services/categorias-gastos.service';
import { GastosService } from '../../../services/gastos.service';
import { SubcategoriasGastosService } from '../../../services/subcategorias-gastos.service';
import { SucursalesService } from '../../../services/sucursales.service';
import { HelpersService } from '../../../services/tools/helpers.service';
declare var $;
@Component({
  selector: 'app-update-gasto',
  templateUrl: './update-gasto.component.html',
  styleUrls: ['./update-gasto.component.scss']
})
export class UpdateGastoComponent implements OnInit {

  @ViewChild(ErrorModalComponent) errorModal: ErrorModalComponent;

  public selected: any = {};
  public dataUpdate: any = { descripcion:"", monto:0};
  public errors: any = {};
  public processing: boolean = false;
  public isUpdate: boolean = true;
  public categoriaSelected: any = {};
  public categoriasFilterOptions: any[];
  public subcategoriaSelected: any = {};
  public subcategoriasFilterOptions: any[];
  public sucursalesFilterOptions: any[];
  public sucursalesSelected: any = {};
  public gastoIdData : any = [];
  public formaPago: string ="";

  public sucursalPorDefecto: string = "";
  @Output() public goToCallback: EventEmitter<string> = new EventEmitter;
  
  constructor(
    private gastosService: GastosService,
    private categoriasService: CategoriasGastosService,
    private sucursalesService: SucursalesService,
    private subcategoriasService: SubcategoriasGastosService,
    private helperService: HelpersService,
    public dialogRef: MatDialogRef<UpdateGastoComponent>,
    @Inject (MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.selected = this.gastosService.getDefaultSchedule();
    this.categoriaSelected = this.categoriasService.getDefaultSchedule();
    this.subcategoriaSelected = this.subcategoriasService.getDefaultSchedule();
    this.sucursalesSelected = this.sucursalesService.getDefaultSchedule();
    this.getSucursales();
    this.getCategorias();
    this.getGastoId();
  }

  getSucursales(){
    this.sucursalesService.getSelect().subscribe(
      (response)=>{
        this.sucursalesFilterOptions = response.json().content;
        if (this.sucursalesFilterOptions.length>1){
          this.sucursalPorDefecto = "Seleccione";
        } else if(this.sucursalesFilterOptions.length>0){
          this.sucursalesSelected =  this.sucursalesFilterOptions[0];
        }
      }, error => {
        this.processing = false;

        // se resuelven los errores 403 y 500
        this.helperService.httpGlobalError(error, false);

        if (error.status == 400 || error.status == 500) {
          this.helperService.notification('ERROR', 'Sucedió un error obtener el listado de sucursales. Por favor, intenta más tarde.', 'error');
        }
    });
  }

  getCategorias(){
    this.categoriasService.getSelect().subscribe(
      (response)=>{
        this.categoriasFilterOptions = response.json().content;
      }, error => {
        this.processing = false;

        // se resuelven los errores 403 y 500
        this.helperService.httpGlobalError(error, false);

        if (error.status == 400 || error.status == 500) {
          this.helperService.notification('ERROR', 'Sucedió un error obtener el listado de categorías. Por favor, intenta más tarde.', 'error');
        }
    });
  }

  getSubcategorias(){
    this.subcategoriasService.getSelect(this.categoriaSelected.id).subscribe(
      (response)=>{
        this.subcategoriasFilterOptions = response.json().content;
      }, error => {
        this.processing = false;

        // se resuelven los errores 403 y 500
        this.helperService.httpGlobalError(error, false);

        if (error.status == 400 || error.status == 500) {
          this.helperService.notification('ERROR', 'Sucedió un error obtener el listado de subcategorías. Por favor, intenta más tarde.', 'error');
        }
    });
  }
  public formaPagoTexto(opc: number){
    switch(opc){
      case 1: return "Efectivo";
      case 2: return "Transferencia";
      case 3: return "Cheque";
      case 4: return "Tarjeta bancaria";
    }
  }
  public getGastoId(){
    this.gastosService.getGastoById(this.data.idGasto)
      .subscribe(response => {
        const respuesta = response.json();
        if (respuesta.success) {
          this.gastoIdData = respuesta.content[0];
          this.formaPago = this.formaPagoTexto(this.gastoIdData.forma);
          //Agregamos valores iniciales a los input a editar
          this.dataUpdate.descripcion = this.gastoIdData.descripcion;
          this.dataUpdate.monto = this.gastoIdData.monto;
          
          this.helperService.notification('Gasto obtenido', 'Se ha obtenido exitosamente el gasto', 'success');
          //Poner dentro del success response
        }
      }, error => {
        if(error.status == 400) {
          this.showServicesErrors(error.json().content);
        }else{
          
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
        
        // se resuelven los errores 403 y 500
        this.helperService.httpGlobalError(error, false);
      });
  }

  reset() {
    this.selected = {};
    this.isUpdate = false;
    this.errors = {};
    this.categoriaSelected = {};
  }

  public close(){
    this.dialogRef.close({update:false})
  }

  public updateGasto(){
  
    this.gastosService.update(this.dataUpdate, this.data.idGasto)
      .subscribe(response => {
        const respuesta = response.json();
        if (respuesta.success) {
          this.helperService.notification('Gasto actualizado', 'Se ha actualizado exitosamente', 'success');
          //Poner dentro del success response
          this.dialogRef.close({update:true});
        }
      }, error => {
        if(error.status == 400) {
          this.showServicesErrors(error.json().content);
        }else{
          this.dialogRef.close({update:false});
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
        
        // se resuelven los errores 403 y 500
        this.helperService.httpGlobalError(error, false);
      });
  }

  public accept() {
    
    this.errors = [];
    
    this.errors = this.gastosService.validateUpdate(this.dataUpdate);
    
    if(!$.isEmptyObject(this.errors)){
      return false;
    }

    this.processing = true;
    
    if(this.isUpdate){
      console.log("Entro a aceptar validación");
      this.updateGasto();
    }
      //this.update();
    
  }

  changeSucursalesSelected(selected) {
    this.sucursalesSelected = selected;
  }

  changeCategoriasSelected(selected) {
    this.categoriaSelected = selected;
    this.getSubcategorias();
  }

  changeSubcategoriasSelected(selected) {
    this.subcategoriaSelected = selected;
  }
  private showServicesErrors(errors:any[]){
    //Es posible que en algún momento se necesiten parsear los errores ya que las llaves del backend,
    //no correspondan con las llaves de los errores del front
    this.errors = errors;
  }
}



// WEBPACK FOOTER //
// ./src/app/gastos/dialogs/update-gasto/update-gasto.component.ts